import React from "react";
import { Card, CardContent, Skeleton, Stack } from "@mui/material";
import { SkeletonDetailRows } from "../../../common/Utils/Skeleton/SkeletonComponents";

const OrdersDetailsSkeleton = () => (
  <Stack spacing={6} sx={{ py: 2 }}>
    {/* Header card: order ID, action icons, status chip, details + label chips */}
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Skeleton variant="text" width={160} height={40} />
            <Stack direction="row" spacing={1}>
              <Skeleton variant="rounded" width={32} height={32} />
              <Skeleton variant="rounded" width={32} height={32} />
            </Stack>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rounded" width={110} height={24} />
          </Stack>
          <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" spacing={2}>
            <Stack spacing={1}>
              <Skeleton variant="text" width={220} height={32} />
              <SkeletonDetailRows widths={[180, 260]} />
            </Stack>
            <Stack direction="row" spacing={1}>
              <Skeleton variant="rounded" width={80} height={24} />
              <Skeleton variant="rounded" width={80} height={24} />
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>

    {/* Primary details card */}
    <Card>
      <CardContent>
        <Stack spacing={1.5}>
          <Skeleton variant="text" width="40%" height={32} />
          <SkeletonDetailRows widths={['60%', '50%', '55%', '45%']} />
        </Stack>
      </CardContent>
    </Card>
  </Stack>
);

export default OrdersDetailsSkeleton;
